import interceptor from 'rest/interceptor';

const accountRouteInterceptor = interceptor({
    request: (request, config, meta) => {
        if (window.location.pathname.includes('/account')) {
            /**
            * The profile service can't handle extra params
            * so we delete them prior to the call to urbnrest
            * then reattach them to the entity.
            */
            if (request.entity) {
                delete request.entity.accountModel;
                delete request.entity.accountViewModel;
                delete request.entity.accountController;
                delete request.entity.accountSelector;
                delete request.entity.createdAt;
                delete request.entity.lastModifiedAt;
            }
        }

        return request;
    },
    response: (response, config, meta) => {
        if (window.location.pathname.includes('/account')) {
            if (!response.entity) {
                response.entity = {};
            }

            const request = response.request;

            const accountModel = Object.assign({}, request.model);
            const accountViewModel = Object.assign({}, request.viewModel);
            const accountController = Object.assign({}, request.controller);
            const accountSelector = Object.assign({}, request.selector);

            if (_.isObject(response.entity)) {
                response.entity.accountModel = accountModel;
                response.entity.accountViewModel = accountViewModel;
                response.entity.accountController = accountController;
                response.entity.accountSelector = accountSelector;
            }
        }

        return response;
    }
});

export default accountRouteInterceptor;
